(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["kb-product-intro"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{const button=event.target.closest('[data-kb-size]');if(button)document.getElementById(button.dataset.kbSize)?.showModal()});
  } catch(e) { console.error(e); }
})();

})();
